import React, { useEffect, useRef, useState } from 'react';
import GL_logo from '../../assets/Logo/GL Funnel Logo.svg';
import uploadIconActive from '../../assets/Icons/UploadIconActive.svg';
import uploadIcon from '../../assets/Icons/uploadIcon.svg'
import settingIcon from '../../assets/Icons/Setting Icon.svg';
import settingIconActive from '../../assets/Icons/SettingIconActive.svg'
import clientLoginLogo from '../../assets/Logo/clientLoginLogo.png'
import { Link, useNavigate } from 'react-router-dom';



const AppBar = () => {
  const [isUploadOpen, setIsUploadOpen] = useState(true);
  const [isSetupMenuOpen, setIsSetupMenuOpen] = useState(false);
  const navigate = useNavigate();
  const setupMenuRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem('userData'));
  const userName = userData?.user?.name || '';
  const handleSignout = () => {
    localStorage.clear();
    window.location.reload();
 
  };
  const toggleSetupMenu = () => {
    setIsSetupMenuOpen(!isSetupMenuOpen);
    setIsUploadOpen(false)
  };
  const handleClickOutside = (event) => {
    if (setupMenuRef.current && !setupMenuRef.current.contains(event.target)) {
      setIsSetupMenuOpen(false);
      setIsUploadOpen(true); // Ensure upload icon is reset when clicking outside
    }
  };
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (

    <nav className='lg:w-full fixed z-10 top-0 pt-4 flex flex-row justify-between shadow-md bg-customAppBarBackground pb-2'>
        <div className='  lg:mx-16 md:mx-8  lg:flex md:flex  '>
            <img className=' md:w-5 md:h-9 mx-4  lg:w-7 lg:h-12' src={GL_logo} alt="" />
            <span className=' lg:text-3xl md:text-xl md:w-full md:h-6 lg:w-full lg:h-9 font-semibold text-customGreen mt-1 w-full'>GL Funnel</span>
        </div>
        <div className='md:flex md:gap-12 md:ml-5 lg:ml-0 justify-center'>
          <div className='flex flex-col cursor-pointer'
          onClick={()=> navigate('/lead-uploader')}
          >
            
          <img className='lg:w-8 lg:h-8 lg:mx-1.5 md:mx-1.5 md:w-7 md:h-7 '  src={isUploadOpen ? uploadIconActive : uploadIcon} alt="" />
          <span className='font-medium lg:w-10 md:w-6 text-sm lg:mt-2 md:mt-2'>Upload</span>
          </div>
          <div className='flex flex-col justify-center cursor-pointer'
           onClick={toggleSetupMenu} ref={setupMenuRef}
          >
          <img className='lg:w-8 lg:h-8 lg:mx-1.5 md:mx-1.5 md:w-7 md:h-7' src={isSetupMenuOpen?settingIconActive:settingIcon} alt="" />
          <span className='font-medium lg:w-10 md:w-6 text-sm lg:mt-2 md:mt-2'>Setting</span>
          {isSetupMenuOpen && (
            <div className="absolute right-[485px] 4xl:right-[1170px] 3xl:right-[845px] 2xl:right-[655px] xl:right-[525px] custom-xl:right-[605px] top-10 mt-12 bg-white rounded-md shadow-md w-44 py-2">
              <ul>
              <li className="border-b border-gray-300 py-2 text-center" 
              // onClick={() => handleNavigation('/my-profile')}
              >
                      <Link to="/lead-uploader/my-profile">My Profile</Link>
                    </li>
                    <li className="py-2 text-center"
                    //  onClick={handleSignout}
                     >
                      <Link onClick={handleSignout}>Sign Out</Link>
                    </li>
              </ul>
            </div>

          )}
          </div>
 

        </div>
        <div className='flex '>
        <div className='max-w-56 '>
          <span className='font-bold lg:text-lg md:text-base'>{userName}</span><br />
          <span className='font-normal lg:text-lg md:text-base'>Namma Family Builders</span>

          </div>
          <div className='md:mx-8 lg:mx-16'>
            <img className='lg:w-14 lg:h-14 md:w-10 md:h-10' src={clientLoginLogo} alt="" />
          </div>
        </div>
        
    </nav>
    
    
  )
}

export default AppBar
